module.exports = __webpack_public_path__ + "img/Learning-amico.675f79ec.svg";